export const initialState = {
    title: 'Gemba Partners',
    formats: {
        date: 'DD.MM.YYYY'
    }
};

export default (state = initialState, action) => state;